import { type FC } from 'react'
import { useTheme } from '@mui/material/styles'

import { type ListLink as ImageLinkModel } from '@Types/navigation/listLinkGroup'

import LinkBase from '../_internal/LinkBase'
import { type LinkBaseProps } from '../_internal/LinkBase.types'

import * as styles from './styles'

export type ImageLinkProps = Omit<LinkBaseProps<'a'>, 'underline' | 'isInline' | 'hasDefaultFocusVisible' | 'icon'> &
  Omit<ImageLinkModel, 'label'>

const ImageLink: FC<ImageLinkProps> = ({ children, locale, isNextRoute = false, surface = 'onDefault', ...rest }) => {
  const theme = useTheme()

  return (
    <LinkBase
      {...rest}
      surface={surface}
      css={styles.link(theme, surface)}
      hasNoSpacing
      locale={locale}
      isNextRoute={isNextRoute}
    >
      {children}
    </LinkBase>
  )
}

export default ImageLink
